export default __webpack_public_path__ + "static/media/healing-video-path-illustration.cd12b72b.png";